import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import ids from '../../QestIds';
import { MeasurementsSection } from '../Sections';
import { BsEnIsoDryMassesSection, BsEnIsoPreparationSection, BsEnIsoResultsSection } from './Sections';

const qestIds = [ids.moistureContent.BS_EN_ISO_17892_1.rev2014];

let BsEnIsoMeasuredMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <BsEnIsoPreparationSection />
    <MeasurementsSection />
    <BsEnIsoDryMassesSection />
    <BsEnIsoResultsSection />
  </>
);

BsEnIsoMeasuredMoistureContentWorksheet.qestIds = qestIds;

export default BsEnIsoMeasuredMoistureContentWorksheet;
export { BsEnIsoMeasuredMoistureContentWorksheet };
